//请自行添加语言资源
const statusUpdate = {
  orderNo:'订单编号',
  deliveryNo:'装运单号',
  logisticsStatus:'在途情况',
  planArriveTime:'预计到货日',
  cityName:'城市',
  logisticsCity:'当前所在城市',
  shippingCityCode:'发货城市',
  custCode:'客户编号',
  custName:'客户名称',
  custSite:'客户地址',
  custType:'客户类型',
  customerSubclassType:'客户子类',
  dept:'部门',
  classify:'分类',
  brand:'品牌',
  orderSkuNum:'订单SKU数',
  orderPcsNum:'订单支数',
  totalBoxNum:'总箱数',
  orderWeight:'订单重量',
  orderVol:'订单体积',
  trayNum:'托盘数量',
  transCompany:'运输公司',
  transCompanyCode:'运输公司代码',
  transMode:'运输方式',
  deliverWarehouseCode:'发货仓编码',
  warehouseName:'发货仓名称',
  factoryCode:'工厂编码',
  factoryName:'工厂名称',
  createTime:'订单创建时间',
  planDate: '计划日期',
  orderCreateDate: '订单创建日期',
  add: 'ADD',
  mivFile:'MIV扫描件',
  orderCompleteTime:'订单完成时间',
  delayFlag: '是否延迟',
  delayDays: '延迟天数',
  delayResonCode: '延迟原因',
  delayResonRemark:'延迟原因Remark',
  orderStatus:'订单状态',
  msg:{
  }
};
export default statusUpdate



// WEBPACK FOOTER //
// ./src/page/toBUpdate/statusUpdate/lang/statusUpdate.zh.js